import {http} from './api';

export const RulesService = {
  create: (data, locale) => http.post(`rules`, data, {params: {locale: locale}}),
  update: (data, id, locale) => http.put(`rules/${id}`, data, {params: {locale: locale}}),
  getCategories: (id) => http.get('rules/categories', {id: id}),
  getVariableOptions: (locale) => http.get('rules/variable_options', {locale: locale}),
  getTables: (scope=null) => http.get('rules/tables' + (scope != null ? '?scope=' + scope : '')),
};
